// src/components/Disclaimer.jsx
import React from 'react';
import styles from '../styles/Disclaimer.module.css';
import Nav from '../components/Nav';
import Footer from '../components/Footer';

const Disclaimer = () => {
  return (
    <div><Nav />
      <div className={styles.disclaimerContainer}>

        <header className={styles.header}>
          <h1 className={styles.title}>Disclaimer</h1>
          <p className={styles.subtitle}>StockKhata - Invest Anywhere, Maintain Only Here</p>
        </header>
        <main className={styles.content}>
          <section>
            <h2 className={styles.sectionTitle}>General Information</h2>
            <p>
              StockKhata is a platform designed to help users track and manage their investment portfolios. The information provided on this website, including but not limited to text, graphics, data, and tools, is for general informational purposes only. It is not intended to be a substitute for professional financial advice, nor does it constitute an offer to buy or sell any securities or investments.
            </p>
          </section>

          <section>
            <h2 className={styles.sectionTitle}>No Investment Advice</h2>
            <p>
              StockKhata does not provide investment advice, stock recommendations, or financial planning services. We do not suggest, recommend, or endorse any specific stocks, securities, or investment strategies. Any decision to buy, sell, or hold investments is solely the responsibility of the user. We strongly recommend consulting with a qualified financial advisor or professional before making any investment decisions.
            </p>
          </section>

          <section>
            <h2 className={styles.sectionTitle}>Accuracy of Information</h2>
            <p>
              While StockKhata strives to provide accurate and up-to-date information, we do not guarantee the completeness, reliability, or accuracy of the data presented. Market conditions, stock prices, and other financial information can change rapidly, and users should verify any information before acting on it. StockKhata is not liable for any errors, omissions, or delays in the information provided.
            </p>
          </section>

          <section>
            <h2 className={styles.sectionTitle}>Risk Disclosure</h2>
            <p>
              Investing in stocks and other securities involves inherent risks, including the potential loss of principal. Past performance is not indicative of future results. StockKhata does not guarantee any profits or protection against losses. Users assume full responsibility for any financial risks or losses incurred while using our platform.
            </p>
          </section>

          <section>
            <h2 className={styles.sectionTitle}>Third-Party Links</h2>
            <p>
              Our website may contain links to third-party websites or resources. StockKhata is not responsible for the content, accuracy, or availability of these external sites. Linking to such sites does not imply endorsement or affiliation with StockKhata.
            </p>
          </section>

          <section>
            <h2 className={styles.sectionTitle}>Limitation of Liability</h2>
            <p>
              StockKhata, its affiliates, and its employees shall not be held liable for any direct, indirect, incidental, or consequential damages arising from the use of, or inability to use, our platform or the information provided. This includes, but is not limited to, losses resulting from investment decisions made based on our tools or content.
            </p>
          </section>

          <section>
            <h2 className={styles.sectionTitle}>Contact Us</h2>
            <p>
              If you have any questions about this disclaimer, please contact us at{' '}
              <a href="mailto:info@stockkhata.in" className={styles.link}>
                info@stockkhata.in
              </a>{' '}
              or call us at +91 7500068589.
            </p>
          </section>
        </main>
      </div>
      <Footer />
    </div>


  );
};

export default Disclaimer;